import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./addCustomer.module.scss";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { useNavigate } from "react-router-dom";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch, useSelector } from "react-redux";
import { createCustomer, updateCustomer, getAllCustomer } from "../../store/actions";

const TopInputBox = [
  // {
  //   id: 1,
  //   label: "CUSTOMER ID*",
  //   inputkey: "id",
  //   type: "text",
  // },
  {
    id: 2,
    label: "FULL NAME*",
    inputkey: "fullName",
    type: "text",
  },
  {
    id: 3,
    label: "EMAIL ID*",
    inputkey: "email",

    type: "text",
  },
  {
    id: 4,
    label: "PHONE NUMBER*",
    inputkey: "phoneNumber",
    type: "number",
  },
];
const initialState = {
  fullName: "",
  email: "",
  phoneNumber: "",
};

const AddCustomer = ({ customer = {} }) => {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state?.login?.user?.companyId);
  const [customerDetails, setCustomerDetails] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    setCustomerDetails({
      fullName: customer?.fullName,
      email: customer?.email,
      phoneNumber: customer?.phoneNumber,
    });
  }, []);

  console.log("customers data", customerDetails);

  const onInputChange = (key, value = "") => {
    setCustomerDetails({
      ...customerDetails,
      [key]: value,
    });
  };
  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    const payload = {
      fullName: customerDetails?.fullName,
      email: customerDetails?.email,
      phoneNumber: customerDetails?.phoneNumber,
    };
    if (customer?.id) {
      dispatch(
        updateCustomer({
          payload: { ...customer, ...payload },
          callback: {
            success: () => {
              // Refresh list so edits show immediately
              dispatch(getAllCustomer());
              handleCancel();
            },
          },
        })
      );
    } else {
      dispatch(
        createCustomer({
          // The backend saves the body as-is, so status and companyId must be sent
          payload: { ...payload, status: 1, companyId },
          callback: {
            success: () => {
              // Refresh list so new customer appears
              dispatch(getAllCustomer());
              handleCancel();
            },
          },
        })
      );
    }
  };

  return (
    <>
      {" "}
      <StatusCard
        leftContent={customer?.id ? "EDIT CUSTOMER" : "Add CUSTOMER"} // or any icon/component
      />
      <div className={styles.container}>
        <Paper
          elevation={2}
          className={styles.wrapper}
          sx={{ borderRadius: "20px" }}
        >
          <div className={styles.top}>
            <Row className={styles.inputRow}>
              {TopInputBox.map((item) => (
                <Col key={item.id}>
                  <FormControl className={styles.inputContainer}>
                    <InputLabel htmlFor={`outlined-input-${item.inputkey}`}>
                      {item.label}
                    </InputLabel>
                    <OutlinedInput
                      className={styles.input}
                      id={`outlined-input-${item.inputkey}`}
                      label={item.label}
                      value={customerDetails[item.inputkey] || ""}
                      type={item.type || "text"}
                      onChange={(e) =>
                        onInputChange(item.inputkey, e.target.value)
                      }
                    />
                  </FormControl>
                </Col>
              ))}
            </Row>
          </div>

          <div className={styles.buttonCotainer}>
            <div className={styles.bottomLeft}>
              {/* Add Back Button Here if needed */}
            </div>
          </div>
        </Paper>

        <div className={styles.bottomRight}>
          <OutlinedButton
            title={"Cancel"}
            txtClr={"hsla(187, 98%, 16%, 1)"}
            border={"1px solid hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onclick={handleCancel}
          />
          <CustomButton
            title={"Submit"}
            txtClr={"#FFFFFF"}
            background={"hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    customer: state?.customer?.customer,
  };
};

export default connect(mapStateToProps, null)(AddCustomer);
